import {Box, Tabs, Tab, CircularProgress, Stack} from "@mui/material";
import React from "react";
import {TabPanel} from "../../components/common/TabPanel";
import { pageAuthorizedByGroup } from "../fragments/PageAuthorization";
import {MailexSearch} from "./components/search/MailexSearch";
import {MailexSets} from "./components/sets/MailexSets";
import {MailexUpload} from "./components/upload/MailexUpload";
import {CurrentStageDisplay, HeaderSlot} from "../../components/onsite/Footer";

const MailexHomePageContent = () => {
	const [value, setValue] = React.useState(1);
	const [loading, setLoading] = React.useState(false);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	function getTabProps(index: number) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	return <>
		<HeaderSlot><CurrentStageDisplay/></HeaderSlot>
		<Box sx={{ width: "100%", height: "100%" }}>
			<Stack position={"relative"} style={{height: "100%"}}>
				<div style={{flexGrow: 0}}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label="basic tabs example"
						>
							<Tab label="Upload" {...getTabProps(0)} />
							<Tab label="Sets" {...getTabProps(1)} />
							<Tab label="Errors" {...getTabProps(2)} />
							<Tab label="Search" {...getTabProps(3)} />
						</Tabs>
					</Box>
				</div>
				<div style={{flexGrow: 1}}>
					<TabPanel value={value} index={0}>
						<MailexUpload success={() => setValue(1)}  />
					</TabPanel>
					<TabPanel value={value} index={1}>
						<MailexSets setLoading={setLoading} />
					</TabPanel>
					<TabPanel value={value} index={3}>
						<MailexSearch />
					</TabPanel>
				</div>
			</Stack>
			{loading && <div style={{
				position: "absolute",
				width: "100%", height: "100%",
				backgroundColor: "white",
				zIndex: 9,
				opacity: "0.7",
				top: 0,
				display: "flex",
				justifyContent: "space-around",
				alignItems: "center",
			}}>
				<CircularProgress />
			</div>}
		</Box>
	</>;
};

export const MailexHomePage = pageAuthorizedByGroup(MailexHomePageContent, ["Admin", "MailEx"]);
